// extracted by mini-css-extract-plugin
export var tosLink = "_8g-0";